<h1 mat-dialog-title>{{data.actionName | titlecase }} {{ data.entity | titlecase }}</h1>
<div mat-dialog-content>
    <p>Warning, this {{ data.entity | titlecase }} has a balance in his account. </p>
    <p>Are you sure that you want to continue {{data.actionName}}ing the {{ data.entity }}?</p>
</div>
<div class="float-right" mat-dialog-actions>
    <button (click)="apply()" cdkFocusInitial  class="font-weight-bold" color="primary" mat-button>Confirm</button>
    <button (click)="cancel()" mat-button>Cancel</button>
</div>
